import { IUserReport } from "./users.types";

// Reports Summary Component Types
export interface IReportsSummaryProps {
  user: IUserReport;
  onClose: () => void;
}

// Error Handling Types
export interface IDownloadError {
  message: string;
  status?: number;
  originalError?: unknown;
}

export interface IEmailSendResult {
  success: boolean;
  error?: string;
}

export interface IEmailSendError {
  message: string;
  originalError?: unknown;
}

// RTK Query error type
export interface IRTKQueryError {
  data?: unknown;
  message?: string;
  status?: number;
}

// Utility Types
export type TPreviewUrl = string | null;
export type TReportStatus = 1 | 0;
export type TReportType = 1 | 2 | 3;

// Type Guards
export const isActiveReport = (report: {
  status: number;
  type: number;
}): report is { status: 1; type: number } => {
  return report.status === 1;
};
